import ConfigManager from "@/config/ConfigManager"
import Utility from "@/helper/Utility"

export const SearchModel = function () {
    this.province = null
    this.district = null
    this.subDistrict = null

    this.carBrand = null

    this.searchType = "G" // default as garage
    this.recommended = true
    this.truck = false

    this.loadCache()
}

SearchModel.prototype.clear = function () {
    // type
    if (this.searchType == 'G') {
        this.recommended = true
        this.truck = false
    } else if (this.searchType == 'D') {
        this.carBrand = null
    }
}

SearchModel.prototype.saveCache = function () {
    let json = JSON.stringify(this)
    sessionStorage.setItem("search.query", json)

    return this
}

SearchModel.prototype.loadCache = function () {
    let raw = sessionStorage.getItem("search.query")
    if (!Utility.isEmptyStr(raw)) {
        let json = JSON.parse(raw)
        // console.log(json)
        this.searchType = json.searchType ?? "G"

        this.province = json.province ?? null
        this.district = json.district ?? null
        this.subDistrict = json.subDistrict ?? null

        this.recommended = json?.recommended ?? true
        this.truck = json.truck ?? false
        this.carBrand = json.carBrand ?? null
    }

    return this
}

SearchModel.prototype.getParams = function () {
    let json = {
        agencyId: ConfigManager.getAgencyId(),
        province_code: this.province,
        district_code: this.district,
        subdistrict_code: this.subDistrict,
        category: this.searchType,
        // extra
        require_campaign: false,
        expert: "",
        recommended: "",
        truck_garage: "",
    }
    if (this.searchType == "G") {
        json.recommended = this.recommended
        json.expert = ""
        json.truck_garage = this.truck  
    }
    else if (this.searchType == "D") {
        json.recommended = ""
        json.expert = this.carBrand
        json.truck_garage = ""
    } else {
        json.recommended = ""
        json.expert = ""
        json.truck_garage = ""
    }

    // console.log(json)

    return json
}

export default SearchModel